// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1j-o";
export var animationRelative = "_1j-n";
export var backdropBlur = "_1j-0";
export var detailLabelCell = "_1j-10";
export var detailTable = "_1j-z";
export var detailValueCell = "_1j-11";
export var docIconBox = "_1j-19";
export var docTypeRow = "_1j-14";
export var docTypeRowInner = "_1j-15";
export var dropdownMatchDatePicker = "_1j-1";
export var fileUploadSpin = "_1j-h";
export var gorgiasOpenButton = "_1j-13 _1j-b";
export var gorgiasTicketCard = "_1j-12";
export var heroModalFooterButton = "_1j-16";
export var hiddenContainer = "_1j-m";
export var maxWidthContainer = "_1j-17";
export var modalContentBody = "_1j-8";
export var modalHeaderImage = "_1j-3";
export var modalImageLabel = "_1j-5";
export var modalImageOverlay = "_1j-4";
export var modalImageSubtitle = "_1j-7";
export var modalImageTitle = "_1j-6";
export var modalImageWrapper = "_1j-2";
export var modalStickyFooter = "_1j-9";
export var removeButton = "_1j-c";
export var sidebarColumn = "_1j-18";
export var spinner = "_1j-g";
export var timelineLine = "_1j-w";
export var timelineLineBlack = "_1j-y _1j-w";
export var timelineLineGray = "_1j-x _1j-w";
export var timelineLineHeight = "_1j-v";
export var tlDotActivate = "_1j-s";
export var tlDotActivateAnim = "_1j-r";
export var tlDotHide = "_1j-q";
export var tlDotHideAnim = "_1j-p";
export var tlLineActivate = "_1j-u";
export var tlLineActivateAnim = "_1j-t";
export var uploadHint = "_1j-l";
export var uploadIconBox = "_1j-i";
export var uploadLabel = "_1j-k";
export var uploadText = "_1j-j";
export var uploadZone = "_1j-d";
export var uploadZoneCursorDefault = "_1j-f";
export var uploadZoneCursorPointer = "_1j-e";
export var uploadedFileRow = "_1j-a";
export var viewButton = "_1j-b";